import React, { useState, useContext, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Typography, Button, TableSortLabel } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import { Link } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import * as Constants from '../Constants';
import '../App.css';

const EventList = () => {
  const [events, setEvents] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchEvents = async () => {
      const params = {
        _site: user._site._id,
      };
      rpc({
        method: "GetEvents",
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: setEvents
      });
    };
    fetchEvents();
  }, [user]);
  
  const onUpload = () => {
    navigate('/uploadVideo');
  };

  const createBingo = () => {
    navigate(`/createEvent/${Constants.EVENT_BINGO}`);
  };

  const createJitsi = () => {
    navigate(`/createEvent/${Constants.EVENT_JITSI}`);
  };

  const createText = () => {
    navigate(`/createEvent/${Constants.EVENT_TEXT_EVENT}`);
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedEvents = events.slice().sort((a, b) => {
    if (orderBy === 'name') {
      return (order === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name));
    }
    return 0;
  });

  const getButtons = () => {
    const bingo = events.find((event) => {
      return event.type === Constants.EVENT_BINGO;
    });
    const jitsi = events.find((event) => {
      return event.type === Constants.EVENT_JITSI;
    });
    return (
      <div className="HorizontalContainer">
        <Button className="Button" variant="contained" color="primary" onClick={onUpload}>
          Upload Video
        </Button>
        <Button disabled={bingo !== undefined} className="Button" variant="contained" color="primary" onClick={createBingo}>
          Bingo
        </Button>
        <Button disabled={jitsi !== undefined} className="Button" variant="contained" color="primary" onClick={createJitsi}>
          Video Conference
        </Button>
        <Button className="Button" variant="contained" color="primary" onClick={createText}>
          Reminder
        </Button>
      </div>
    );
  };
  
  const getPlayImmediately = (event) => {
    const playAttr = event.attributes.find((attr) => {
      return (attr.name === Constants.ATTR_PLAY_IMMEDIATELY);
    });
    return playAttr ? playAttr.value: 'false';
  };

  return (
    <div className="EventList">
      <Typography variant="h6" gutterBottom>
        Events
      </Typography>
      <TableContainer className="TableContainer" component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === 'name'}
                  direction={orderBy === 'name' ? order : 'asc'}
                  onClick={() => handleSort('name')}
                >
                  <b>Name</b>
                </TableSortLabel>
              </TableCell>
              <TableCell><b>Display Name</b></TableCell>
              <TableCell><b>Description</b></TableCell>
              <TableCell><b>Type</b></TableCell>
              <TableCell><b>Immediate</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedEvents.map((event, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Link to={`/event/${event._id}`}>{event.name}</Link>
                </TableCell>
                <TableCell>{event.displayName}</TableCell>
                <TableCell>{event.description}</TableCell>
                <TableCell>{Constants.EVENT_NAMES[event.type]}</TableCell>
                <TableCell>{getPlayImmediately(event)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {getButtons()}
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default EventList;
